import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-redirection',
  templateUrl: './redirection.component.html',
  styleUrls: ['./redirection.component.css']
})
export class RedirectionComponent implements OnInit {

  constructor( private router: Router,public translate: TranslateService) { }
  @Input('message') message: string;
  ngOnInit() {
    var paymentLoader = document.createElement("div");
    paymentLoader.setAttribute("id", "overlay-redirection");
    var loader = document.getElementById("loading-bar-spinner-component");
    loader.parentNode.insertBefore(paymentLoader, loader.nextSibling);
    (<HTMLElement>document.getElementsByTagName("main")[0]).style.zIndex = "10";
  }

}
